import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const createProcessUseCase = async (body: FormData) => {
  try {
    const state = store.getState();

    const namespace = state?.yourSlice?.authContext?.customerNamespace;
    const source_id = state?.yourSlice?.connectionView?.source?.source_id;

    const response = await apiUseCases.createProcessApi(
      namespace,
      source_id,
      body,
    );

    return {
      success: true,
      data: response,
      statusCode: response?.status,
    };
  } catch (error) {
    const parsedError = parseAxiosApiError(error, "Failed to create process");

    return {
      success: false,
      error: parsedError.message,
      statusCode: parsedError.status,
    };
  }
};
